import React, { useEffect, useState } from 'react'
import { mamorioIcon } from '../../icons'
import { fetchGroupMamorioCount } from '../../modules/Mamorio'
import { getErrorString } from '../../utils/errorUtils'
import './GroupMamorioCount.css'

type GroupMamorioCountProps = {
  groupId?: GroupId | null
}

const GroupMamorioCount = ({ groupId }: GroupMamorioCountProps) => {
  const [mamorioCount, setMamorioCount] = useState<number | null>(null)

  useEffect(() => {
    if (!groupId || Number.isNaN(Number(groupId))) {
      setMamorioCount(null)
      return undefined
    }

    let isActive = true
    setMamorioCount(null)
    fetchGroupMamorioCount(groupId)
      .then((count) => {
        if (isActive) {
          setMamorioCount(count)
        }
      })
      .catch((error: unknown) => {
        if (isActive) {
          setMamorioCount(null)
        }
        console.error(getErrorString(error))
      })

    return () => {
      isActive = false
    }
  }, [groupId])

  if (mamorioCount === null) {
    return null
  }

  return (
    <div
      className="group-mamorio-count"
      data-testid="group-mamorio-count"
      aria-label={`登録MAMORIO数 ${mamorioCount}`}
    >
      <img src={mamorioIcon} alt="" />
      <strong>{mamorioCount}</strong>
    </div>
  )
}

export default GroupMamorioCount
